import { render, staticRenderFns } from "./0023.vue?vue&type=template&id=fe67eb86&scoped=true&"
import script from "./0023.vue?vue&type=script&lang=js&"
export * from "./0023.vue?vue&type=script&lang=js&"
import style0 from "./0023.vue?vue&type=style&index=0&id=fe67eb86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe67eb86",
  null
  
)

export default component.exports